import { post } from '@/util/http'

/**
 * 新增实体
 *
 * @param {Object} vo 接收新增参数的VO对象
 * @return Result
 */
export const insertFemsNotice = params => post(`/femsNotice/femsNotice/insert`, params);
/**
 * 根据id更新实体, 全部字段覆盖更新
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateAllColumnFemsNotice = params => post(`/femsNotice/femsNotice/updateAllColumn`, params);
/**
 * 根据id列表批量更新非空字段
 *
 * @param {Object} vo        更新非空字段
 * @param {Object} listParam ListParam.lsIds批量更新的id列表
 * @return Result
 */
export const updateBatchFemsNotice = params => post(`/femsNotice/femsNotice/updateBatch`, params);
/**
 * 根据id删除实体
 *
 * @param {String} id 删除该id的实体
 * @return Result
 */
export const deleteByIdFemsNotice = params => post(`/femsNotice/femsNotice/deleteById`, params);
/**
 * 根据id列表批量删除数据
 *
 * @param {Object} listParam ListParam.lsIds批量删除的id列表
 * @return Result
 */
export const deleteBatchIdsFemsNotice = params => post(`/femsNotice/femsNotice/deleteBatchIds`, params);
/**
 * 获取查询列表
 *
 * @param vo 接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectListFemsNotice = params => post(`/femsNotice/femsNotice/selectList`, params);
/**
 * 分页查询获取列表
 *
 * @param {Object} pager 通用查询分页对象
 * @param {Object} vo    接收查询参数的VO对象, 支持fuzzyText属性模糊查询
 * @return Result
 */
export const selectPageFemsNotice = params => post(`/femsNotice/femsNotice/selectPage`, params);
/**
 * 根据id更新实体，仅更新非空字段
 *
 * @param {Object} vo 接收更新参数的VO对象
 * @return Result
 */
export const updateFemsNotice = params => post(`/femsNotice/femsNotice/update`, params);
/**
 * 获取查询结果统计记录数
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const selectCountFemsNotice = params => post(`/femsNotice/femsNotice/selectCount`, params);
/**
 * 查询自己通知消息
 *
 * @param {Object} vo 接收查询参数的VO对象
 * @return Result
 */
export const selectMyFemsNotice = params => post(`/femsNotice/femsNotice/selectMyNotice`, params);

/**
 * 标记当前用户已读该通知，即收到并已经阅读该通知
 *
 * @param noticeId 通知ID
 * @return Result 结果对象
 */
export const updateFemsNoticeForRead = params => post(`/femsNotice/femsNotice/updateForRead`, params);
